<header *ngIf="isEmbedded" class="embeddedMobileHeader">
    <button class="closeIcon" aria-label="Close" (click)="back()">
        <mat-icon *ngIf="!backText" svgIcon="cc-chevron-left" style="width: 18px" alt="Go Back"></mat-icon>
        <span *ngIf="backText">{{ backText }}</span>
    </button>
    <p class="customerPortal">
        <span *ngIf="!isTitleEditable">{{ pageTitle }}</span>
        <input *ngIf="isTitleEditable" class="customerPortal" [ngModel]="pageTitle" (input)="onTitleUpdate($event)" />
    </p>
</header>
